import { render, staticRenderFns } from "./proyecto-rsc.vue?vue&type=template&id=659b2efa"
import script from "./proyecto-rsc.vue?vue&type=script&lang=js"
export * from "./proyecto-rsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports